import React from "react";
import ItemRow from "@/components/ItemRow";
import { EmptyState } from "@/components/EmptyState";
import { relativeDateLabel } from "@/lib/dates";

// Tasks tab body — search-result mode + normal today-list mode.
export default function TaskList({
    q, query, searchLoading, results,
    today, tasks,
    onSearchToggle, onSearchDelete,
    onToggleTask, onDeleteTask, onEditTask, onOpenEditTask,
    onStartFocus, pomodoro, recentFocusMap, inFocusTaskId,
    mochiPickTaskId, avatarStyle,
}) {
    if (q) {
        if (results.length === 0) {
            return <EmptyState text={searchLoading ? "Searching…" : `No tasks match "${query}".`} />;
        }
        return results.map((r) => (
            <ItemRow
                key={r.id}
                title={r.title}
                completed={r.completed}
                priority={r.priority}
                time={r.time}
                dateChip={relativeDateLabel(r.date, today)}
                onToggle={() => onSearchToggle(r)}
                onDelete={() => onSearchDelete(r)}
                onOpenEdit={onOpenEditTask ? () => onOpenEditTask(r) : undefined}
                recentlyFocused={!!recentFocusMap?.[r.id]}
                testId={`task-row-${r.id}`}
            />
        ));
    }
    return (
        <>
            {tasks.length === 0 && <EmptyState text="No tasks yet — add what's on your mind." />}
            {tasks
                .slice()
                .sort((a, b) => {
                    // In-focus task floats to the very top of the list during
                    // an overwhelm session — gentle visual anchor for what
                    // matters right now.
                    if (inFocusTaskId) {
                        if (a.id === inFocusTaskId) return -1;
                        if (b.id === inFocusTaskId) return 1;
                    }
                    return Number(a.completed) - Number(b.completed)
                        || a.created_at.localeCompare(b.created_at);
                })
                .map((t) => (
                    <ItemRow
                        key={t.id}
                        title={t.title}
                        completed={t.completed}
                        priority={t.priority}
                        time={t.due_time}
                        showCountdown={!!t.due_time}
                        onToggle={() => onToggleTask(t)}
                        onDelete={() => onDeleteTask(t)}
                        onEditTitle={onEditTask ? (next) => onEditTask(t, { title: next }) : undefined}
                        onEditPriority={onEditTask ? (next) => onEditTask(t, { priority: next }) : undefined}
                        onOpenEdit={onOpenEditTask ? () => onOpenEditTask(t) : undefined}
                        avatarStyle={avatarStyle}
                        recurrence={
                            t.recurrence_type && t.recurrence_type !== "none"
                                ? {
                                    type: t.recurrence_type,
                                    interval: t.recurrence_interval,
                                    unit: t.recurrence_unit,
                                    day: t.recurrence_day,
                                    month: t.recurrence_month,
                                }
                                : null
                        }
                        onStartFocus={(focusMin, breakMin) => onStartFocus(t, focusMin, breakMin)}
                        isFocusing={pomodoro?.reminderId === t.id || inFocusTaskId === t.id}
                        recentlyFocused={!!recentFocusMap?.[t.id]}
                        mochiPick={mochiPickTaskId === t.id && !t.completed}
                        testId={`task-row-${t.id}`}
                    />
                ))}
        </>
    );
}
